import { AppHeaderSpa } from './AppHeaderSpa';

interface AppHeaderWithLanguageProps {
  menuOpen?: boolean;
  onToggleMenu?: () => void;
}

export function AppHeaderWithLanguage(props: AppHeaderWithLanguageProps) {
  return <AppHeaderSpa {...props} />;
}
